import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  isManager,
  MANAGER_HIDDEN_MENU_IDS,
  MANAGER_HIDDEN_ACCOUNT_SUBMENU_IDS,
} from "../helpers/rbac_helper";

const Navdata = () => {
  const history = useNavigate();
  //state data
  const [isDashboard, setIsDashboard] = useState(false);
  const [isApps, setIsApps] = useState(false);
  const [isAuth, setIsAuth] = useState(false);
  const [isPages, setIsPages] = useState(false);
  const [isBaseUi, setIsBaseUi] = useState(false);
  const [isAdvanceUi, setIsAdvanceUi] = useState(false);
  const [isForms, setIsForms] = useState(false);
  const [isTables, setIsTables] = useState(false);
  const [isCharts, setIsCharts] = useState(false);
  const [isIcons, setIsIcons] = useState(false);
  const [isMaps, setIsMaps] = useState(false);
  const [isMultiLevel, setIsMultiLevel] = useState(false);

  //Calender
  const [isCalender, setCalender] = useState(false);

  // Apps
  const [isEmail, setEmail] = useState(false);
  const [isSubEmail, setSubEmail] = useState(false);
  const [isEcommerce, setIsEcommerce] = useState(false);
  const [isProjects, setIsProjects] = useState(false);
  const [isTasks, setIsTasks] = useState(false);
  const [isCRM, setIsCRM] = useState(false);
  const [isCrypto, setIsCrypto] = useState(false);
  const [isInvoices, setIsInvoices] = useState(false);
  const [isSupportTickets, setIsSupportTickets] = useState(false);
  const [isNFTMarketplace, setIsNFTMarketplace] = useState(false);
  const [isJobs, setIsJobs] = useState(false);
  const [isJobList, setIsJobList] = useState(false);
  const [isCandidateList, setIsCandidateList] = useState(false);

  // Authentication
  const [isSignIn, setIsSignIn] = useState(false);
  const [isSignUp, setIsSignUp] = useState(false);
  const [isPasswordReset, setIsPasswordReset] = useState(false);
  const [isPasswordCreate, setIsPasswordCreate] = useState(false);
  const [isLockScreen, setIsLockScreen] = useState(false);
  const [isLogout, setIsLogout] = useState(false);
  const [isSuccessMessage, setIsSuccessMessage] = useState(false);
  const [isVerification, setIsVerification] = useState(false);
  const [isError, setIsError] = useState(false);

  // Pages
  const [isProfile, setIsProfile] = useState(false);
  const [isLanding, setIsLanding] = useState(false);
  const [isBlog, setIsBlog] = useState(false);

  // Account
  const [isAccount, setIsAccount] = useState(false);

  // Partners
  const [isPartners, setIsPartners] = useState(false);

  // Transactions
  const [isTransactions, setIsTransactions] = useState(false);

  // MAM
  const [isMAM, setIsMAM] = useState(false);

  // Trades
  const [isTrades, setIsTrades] = useState(false);

  // Apps (Application Management)
  const [isAppManagement, setIsAppManagement] = useState(false);

  // Setting
  const [isSetting, setIsSetting] = useState(false);
  const [isPaymentMethods, setIsPaymentMethods] = useState(false);

  // Admins
  const [isAdmins, setIsAdmins] = useState(false);

  // Reports
  const [isReports, setIsReports] = useState(false);

  const [iscurrentState, setIscurrentState] = useState("Dashboard");

  function updateIconSidebar(e) {
    if (e && e.target && e.target.getAttribute("subitems")) {
      const ul = document.getElementById("two-column-menu");
      const iconItems = ul.querySelectorAll(".nav-icon.active");
      let activeIconItems = [...iconItems];
      activeIconItems.forEach((item) => {
        item.classList.remove("active");
        var id = item.getAttribute("subitems");
        if (document.getElementById(id))
          document.getElementById(id).classList.remove("show");
      });
    }
  }

  useEffect(() => {
    document.body.classList.remove("twocolumn-panel");
    if (iscurrentState !== "Dashboard") {
      setIsDashboard(false);
    }
    if (iscurrentState !== "Apps") {
      setIsApps(false);
    }
    if (iscurrentState !== "Auth") {
      setIsAuth(false);
    }
    if (iscurrentState !== "Pages") {
      setIsPages(false);
    }
    if (iscurrentState !== "BaseUi") {
      setIsBaseUi(false);
    }
    if (iscurrentState !== "AdvanceUi") {
      setIsAdvanceUi(false);
    }
    if (iscurrentState !== "Forms") {
      setIsForms(false);
    }
    if (iscurrentState !== "Tables") {
      setIsTables(false);
    }
    if (iscurrentState !== "Charts") {
      setIsCharts(false);
    }
    if (iscurrentState !== "Icons") {
      setIsIcons(false);
    }
    if (iscurrentState !== "Maps") {
      setIsMaps(false);
    }
    if (iscurrentState !== "MuliLevel") {
      setIsMultiLevel(false);
    }
    // if (iscurrentState === "Widgets") {
    //   history("/widgets");
    //   document.body.classList.add("twocolumn-panel");
    // }
    if (iscurrentState !== "Landing") {
      setIsLanding(false);
    }
    if (iscurrentState !== "Account") {
      setIsAccount(false);
    }
    if (iscurrentState !== "Partners") {
      setIsPartners(false);
    }
    if (iscurrentState !== "Transactions") {
      setIsTransactions(false);
    }
    if (iscurrentState !== "MAM") {
      setIsMAM(false);
    }
    if (iscurrentState !== "Trades") {
      setIsTrades(false);
    }
    if (iscurrentState !== "AppManagement") {
      setIsAppManagement(false);
    }
    if (iscurrentState !== "Setting") {
      setIsSetting(false);
    }
    if (iscurrentState !== "Admins") {
      setIsAdmins(false);
    }
    if (iscurrentState !== "Reports") {
      setIsReports(false);
    }
  }, [
    history,
    iscurrentState,
    isDashboard,
    isApps,
    isAccount,
    isPartners,
    isTransactions,
    isMAM,
    isTrades,
    isSetting,
    isAdmins,
    isReports,
  ]);

  const menuItems = [
    {
      label: "Menu",
      isHeader: true,
    },
    {
      id: "dashboard",
      label: "Dashboards",
      icon: "ri-dashboard-2-line",
      link: "/dashboard",
      stateVariables: isDashboard,
      // click: function (e) {
      //   e.preventDefault();
      //   setIsDashboard(!isDashboard);
      //   setIscurrentState("Dashboard");
      //   updateIconSidebar(e);
      // },
      // subItems: [
      //   {
      //     id: "analytics",
      //     label: "Analytics",
      //     link: "/dashboard-analytics",
      //     parentId: "dashboard",
      //   },
      //   {
      //     id: "crm",
      //     label: "CRM",
      //     link: "/dashboard-crm",
      //     parentId: "dashboard",
      //   },
      //   {
      //     id: "ecommerce",
      //     label: "Ecommerce",
      //     link: "/dashboard",
      //     parentId: "dashboard",
      //   },
      //   {
      //     id: "crypto",
      //     label: "Crypto",
      //     link: "/dashboard-crypto",
      //     parentId: "dashboard",
      //   },
      //   {
      //     id: "projects",
      //     label: "Projects",
      //     link: "/dashboard-projects",
      //     parentId: "dashboard",
      //   },
      //   {
      //     id: "nft",
      //     label: "NFT",
      //     link: "/dashboard-nft",
      //     parentId: "dashboard",
      //   },
      //   {
      //     id: "job",
      //     label: "Job",
      //     link: "/dashboard-job",
      //     parentId: "dashboard",
      //     // badgeColor: "success",
      //     // badgeName: "New",
      //   },
      //   {
      //     id: "blog",
      //     label: "Blog",
      //     link: "/dashboard-blog",
      //     parentId: "dashboard",
      //     badgeColor: "success",
      //     badgeName: "New",
      // },
      // ],
    },
    {
      // label: "Account",
      // isHeader: true,
    },
    {
      id: "account",
      label: "Account",
      icon: "ri-user-settings-line",
      link: "/#",
      click: function (e) {
        e.preventDefault();
        setIsAccount(!isAccount);
        setIscurrentState("Account");
        updateIconSidebar(e);
      },
      stateVariables: isAccount,
      subItems: [
        {
          id: "addNewUser",
          label: "Add New User",
          link: "/add-user",
          parentId: "account",
        },
        {
          id: "registeredUser",
          label: "Registered User",
          link: "/account-registered-user",
          parentId: "account",
        },
        {
          id: "kyc",
          label: "KYC",
          link: "/account-kyc",
          parentId: "account",
        },
        {
          id: "aiAccessRequests",
          label: "AI Access Requests",
          link: "/account-ai-access-requests",
          parentId: "account",
        },
        {
          id: "liveTradingAccounts",
          label: "MT5 Live Trading Accounts",
          link: "/account-live-trading",
          parentId: "account",
        },
        {
          id: "myntLiveTradingAccounts",
          label: "MYNT Live Trading Accounts",
          link: "/mynt-live-trading-accounts",
          parentId: "account",
        },
        {
          id: "liveExposureSummary",
          label: "Live Exposure Summary",
          link: "/account-live-exposure",
          parentId: "account",
        },
      ],
    },
    // {
    //   id: "apps",
    //   label: "Apps",
    //   icon: "ri-apps-2-line",
    //   link: "/#",
    //   click: function (e) {
    //     e.preventDefault();
    //     setIsApps(!isApps);
    //     setIscurrentState("Apps");
    //     updateIconSidebar(e);
    //   },
    //   stateVariables: isApps,
    //   subItems: [
    //     {
    //       id: "calendar",
    //       label: "Calendar",
    //       link: "/#",
    //       parentId: "apps",
    //       isChildItem: true,
    //       click: function (e) {
    //         e.preventDefault();
    //         setCalender(!isCalender);
    //       },
    //       stateVariables: isCalender,
    //       childItems: [
    //         {
    //           id: 1,
    //           label: "Main Calender",
    //           link: "/apps-calendar",
    //           parentId: "apps",
    //         },
    //         {
    //           id: 2,
    //           label: "Month Grid",
    //           link: "/apps-calendar-month-grid",
    //           parentId: "apps",
    //         },
    //       ],
    //     },
    //     {
    //       id: "chat",
    //       label: "Chat",
    //       link: "/apps-chat",
    //       parentId: "apps",
    //     },
    //     {
    //       id: "mailbox",
    //       label: "Email",
    //       link: "/#",
    //       parentId: "apps",
    //       isChildItem: true,
    //       click: function (e) {
    //         e.preventDefault();
    //         setEmail(!isEmail);
    //       },
    //       stateVariables: isEmail,
    //       childItems: [
    //         {
    //           id: 1,
    //           label: "Mailbox",
    //           link: "/apps-mailbox",
    //           parentId: "apps",
    //         },
    //         {
    //           id: 2,
    //           label: "Email Templates",
    //           link: "/#",
    //           parentId: "apps",
    //           isChildItem: true,
    //           stateVariables: isSubEmail,
    //           click: function (e) {
    //             e.preventDefault();
    //             setSubEmail(!isSubEmail);
    //           },
    //           childItems: [
    //             {
    //               id: 2,
    //               label: "Basic Action",
    //               link: "/apps-email-basic",
    //               parentId: "apps",
    //             },
    //             {
    //               id: 3,
    //               label: "Ecommerce Action",
    //               link: "/apps-email-ecommerce",
    //               parentId: "apps",
    //             },
    //           ],
    //         },
    //       ],
    //     },
    //     {
    //       id: "appsecommerce",
    //       label: "Ecommerce",
    //       link: "/#",
    //       isChildItem: true,
    //       click: function (e) {
    //         e.preventDefault();
    //         setIsEcommerce(!isEcommerce);
    //       },
    //       parentId: "apps",
    //       stateVariables: isEcommerce,
    //       childItems: [
    //         {
    //           id: 1,
    //           label: "Products",
    //           link: "/apps-ecommerce-products",
    //           parentId: "apps",
    //         },
    //         {
    //           id: 2,
    //           label: "Product Details",
    //           link: "/apps-ecommerce-product-details",
    //           parentId: "apps",
    //         },
    //         {
    //           id: 3,
    //           label: "Create Product",
    //           link: "/apps-ecommerce-add-product",
    //           parentId: "apps",
    //         },
    //         {
    //           id: 4,
    //           label: "Orders",
    //           link: "/apps-ecommerce-orders",
    //           parentId: "apps",
    //         },
    //         {
    //           id: 5,
    //           label: "Order Details",
    //           link: "/apps-ecommerce-order-details",
    //           parentId: "apps",
    //         },
    //         {
    //           id: 6,
    //           label: "Customers",
    //           link: "/apps-ecommerce-customers",
    //           parentId: "apps",
    //         },
    //         {
    //           id: 7,
    //           label: "Shopping Cart",
    //           link: "/apps-ecommerce-cart",
    //           parentId: "apps",
    //         },
    //         {
    //           id: 8,
    //           label: "Checkout",
    //           link: "/apps-ecommerce-checkout",
    //           parentId: "apps",
    //         },
    //         {
    //           id: 9,
    //           label: "Sellers",
    //           link: "/apps-ecommerce-sellers",
    //           parentId: "apps",
    //         },
    //         {
    //           id: 10,
    //           label: "Seller Details",
    //           link: "/apps-ecommerce-seller-details",
    //           parentId: "apps",
    //         },
    //       ],
    //     },
    //     {
    //       id: "appsprojects",
    //       label: "Projects",
    //       link: "/#",
    //       isChildItem: true,
    //       click: function (e) {
    //         e.preventDefault();
    //         setIsProjects(!isProjects);
    //       },
    //       parentId: "apps",
    //       stateVariables: isProjects,
    //       childItems: [
    //         {
    //           id: 1,
    //           label: "List",
    //           link: "/apps-projects-list",
    //           parentId: "apps",
    //         },
    //         {
    //           id: 2,
    //           label: "Overview",
    //           link: "/apps-projects-overview",
    //           parentId: "apps",
    //         },
    //         {
    //           id: 3,
    //           label: "Create Project",
    //           link: "/apps-projects-create",
    //           parentId: "apps",
    //         },
    //       ],
    //     },
    //     {
    //       id: "tasks",
    //       label: "Tasks",
    //       link: "/#",
    //       isChildItem: true,
    //       click: function (e) {
    //         e.preventDefault();
    //         setIsTasks(!isTasks);
    //       },
    //       parentId: "apps",
    //       stateVariables: isTasks,
    //       childItems: [
    //         { id: 1, label: "Kanban Board", link: "/apps-tasks-kanban", parentId: "apps", },
    //         {
    //           id: 2,
    //           label: "List View",
    //           link: "/apps-tasks-list-view",
    //           parentId: "apps",
    //         },
    //         {
    //           id: 3,
    //           label: "Task Details",
    //           link: "/apps-tasks-details",
    //           parentId: "apps",
    //         },
    //       ],
    //     },
    //     {
    //       id: "appscrm",
    //       label: "CRM",
    //       link: "/#",
    //       isChildItem: true,
    //       click: function (e) {
    //         e.preventDefault();
    //         setIsCRM(!isCRM);
    //       },
    //       parentId: "apps",
    //       stateVariables: isCRM,
    //       childItems: [
    //         { id: 1, label: "Contacts", link: "/apps-crm-contacts" },
    //         { id: 2, label: "Companies", link: "/apps-crm-companies" },
    //         { id: 3, label: "Deals", link: "/apps-crm-deals" },
    //         { id: 4, label: "Leads", link: "/apps-crm-leads" },
    //       ],
    //     },
    //     {
    //       id: "appscrypto",
    //       label: "Crypto",
    //       link: "/#",
    //       isChildItem: true,
    //       click: function (e) {
    //         e.preventDefault();
    //         setIsCrypto(!isCrypto);
    //       },
    //       parentId: "apps",
    //       stateVariables: isCrypto,
    //       childItems: [
    //         { id: 1, label: "Transactions", link: "/apps-crypto-transactions" },
    //         { id: 2, label: "Buy & Sell", link: "/apps-crypto-buy-sell" },
    //         { id: 3, label: "Orders", link: "/apps-crypto-orders" },
    //         { id: 4, label: "My Wallet", link: "/apps-crypto-wallet" },
    //         { id: 5, label: "ICO List", link: "/apps-crypto-ico" },
    //         { id: 6, label: "KYC Application", link: "/apps-crypto-kyc" },
    //       ],
    //     },
    //     {
    //       id: "invoices",
    //       label: "Invoices",
    //       link: "/#",
    //       isChildItem: true,
    //       click: function (e) {
    //         e.preventDefault();
    //         setIsInvoices(!isInvoices);
    //       },
    //       parentId: "apps",
    //       stateVariables: isInvoices,
    //       childItems: [
    //         { id: 1, label: "List View", link: "/apps-invoices-list" },
    //         { id: 2, label: "Details", link: "/apps-invoices-details" },
    //         { id: 3, label: "Create Invoice", link: "/apps-invoices-create" },
    //       ],
    //     },
    //     {
    //       id: "supportTickets",
    //       label: "Support Tickets",
    //       link: "/#",
    //       isChildItem: true,
    //       click: function (e) {
    //         e.preventDefault();
    //         setIsSupportTickets(!isSupportTickets);
    //       },
    //       parentId: "apps",
    //       stateVariables: isSupportTickets,
    //       childItems: [
    //         { id: 1, label: "List View", link: "/apps-tickets-list" },
    //         { id: 2, label: "Ticket Details", link: "/apps-tickets-details" },
    //       ],
    //     },
    //     {
    //       id: "NFTMarketplace",
    //       label: "NFT Marketplace",
    //       link: "/#",
    //       isChildItem: true,
    //       click: function (e) {
    //         e.preventDefault();
    //         setIsNFTMarketplace(!isNFTMarketplace);
    //       },
    //       parentId: "apps",
    //       stateVariables: isNFTMarketplace,
    //       childItems: [
    //         { id: 1, label: "Marketplace", link: "/apps-nft-marketplace" },
    //         { id: 2, label: "Explore Now", link: "/apps-nft-explore" },
    //         { id: 3, label: "Live Auction", link: "/apps-nft-auction" },
    //         { id: 4, label: "Item Details", link: "/apps-nft-item-details" },
    //         { id: 5, label: "Collections", link: "/apps-nft-collections" },
    //         { id: 6, label: "Creators", link: "/apps-nft-creators" },
    //         { id: 7, label: "Ranking", link: "/apps-nft-ranking" },
    //         { id: 8, label: "Wallet Connect", link: "/apps-nft-wallet" },
    //         { id: 9, label: "Create NFT", link: "/apps-nft-create" },
    //       ],
    //     },
    //     {
    //       id: "filemanager",
    //       label: "File Manager",
    //       link: "/apps-file-manager",
    //       parentId: "apps",
    //     },
    //     {
    //       id: "todo",
    //       label: "To Do",
    //       link: "/apps-todo",
    //       parentId: "apps",
    //     },
    //     {
    //       id: "job",
    //       label: "Jobs",
    //       link: "/#",
    //       parentId: "apps",
    //       // badgeName: "New",
    //       // badgeColor: "success",
    //       isChildItem: true,
    //       click: function (e) {
    //         e.preventDefault();
    //         setIsJobs(!isJobs);
    //       },
    //       stateVariables: isJobs,
    //       childItems: [
    //         {
    //           id: 1,
    //           label: "Statistics",
    //           link: "/apps-job-statistics",
    //           parentId: "apps",
    //         },
    //         {
    //           id: 2,
    //           label: "Job Lists",
    //           link: "/#",
    //           parentId: "apps",
    //           isChildItem: true,
    //           stateVariables: isJobList,
    //           click: function (e) {
    //             e.preventDefault();
    //             setIsJobList(!isJobList);
    //           },
    //           childItems: [
    //             {
    //               id: 1,
    //               label: "List",
    //               link: "/apps-job-lists",
    //               parentId: "apps",
    //             },
    //             {
    //               id: 2,
    //               label: "Grid",
    //               link: "/apps-job-grid-lists",
    //               parentId: "apps",
    //             },
    //             {
    //               id: 3,
    //               label: "Overview",
    //               link: "/apps-job-details",
    //               parentId: "apps",
    //             },
    //           ],
    //         },
    //         {
    //           id: 3,
    //           label: "Candidate Lists",
    //           link: "/#",
    //           parentId: "apps",
    //           isChildItem: true,
    //           stateVariables: isCandidateList,
    //           click: function (e) {
    //             e.preventDefault();
    //             setIsCandidateList(!isCandidateList);
    //           },
    //           childItems: [
    //             {
    //               id: 1,
    //               label: "List View",
    //               link: "/apps-job-candidate-lists",
    //               parentId: "apps",
    //             },
    //             {
    //               id: 2,
    //               label: "Grid View",
    //               link: "/apps-job-candidate-grid",
    //               parentId: "apps",
    //             },
    //           ],
    //         },
    //         {
    //           id: 4,
    //           label: "Application",
    //           link: "/apps-job-application",
    //           parentId: "apps",
    //         },
    //         {
    //           id: 5,
    //           label: "New Job",
    //           link: "/apps-job-new",
    //           parentId: "apps",
    //         },
    //         {
    //           id: 6,
    //           label: "Companies List",
    //           link: "/apps-job-companies-lists",
    //           parentId: "apps",
    //         },
    //         {
    //           id: 7,
    //           label: "Job Categories",
    //           link: "/apps-job-categories",
    //           parentId: "apps",
    //         },
    //       ],
    //     },
    //     {
    //       id: "apikey",
    //       label: "API Key",
    //       link: "/apps-api-key",
    //       parentId: "apps",
    //       // badgeName: "New",
    //       // badgeColor: "success"
    //     },
    //   ],
    // },
    {
      id: "partners",
      label: "Partners",
      icon: "ri-team-line",
      link: "/#",
      click: function (e) {
        e.preventDefault();
        setIsPartners(!isPartners);
        setIscurrentState("Partners");
        updateIconSidebar(e);
      },
      stateVariables: isPartners,
      subItems: [
        {
          id: "partnerList",
          label: "Partner List",
          link: "/partners-list",
          parentId: "partners",
        },
        {
          id: "currency",
          label: "Currency",
          link: "/partners-currency",
          parentId: "partners",
        },
        {
          id: "assignAccType",
          label: "Assign Acc. Type",
          link: "/partners-assign-acc-type",
          parentId: "partners",
        },
        {
          id: "commissionSettings",
          label: "Commission Settings",
          link: "/partners-commission-settings",
          parentId: "partners",
        },
        // {
        //   id: "withdrawRequests",
        //   label: "Withdraw Requests",
        //   link: "/partners-withdraw-requests",
        //   parentId: "partners",
        // },
      ],
    },
     {
      id: "trades",
      label: "Trades",
      icon: "ri-stock-line",
      link: "/#",
      click: function (e) {
        e.preventDefault();
        setIsTrades(!isTrades);
        setIscurrentState("Trades");
        updateIconSidebar(e);
      },
      stateVariables: isTrades,
      subItems: [
        {
          id: "liveTrades",
          label: "Live Trades",
          link: "/trades-live",
          parentId: "trades",
        },
        {
          id: "closedTrades",
          label: "Closed Trades",
          link: "/trades-closed",
          parentId: "trades",
        },
        {
          id: "shortDurationTrades",
          label: "Short Duration Trades",
          link: "/trades-short-duration",
          parentId: "trades",
        },
        {
          id: "bookManagement",
          label: "Book Management",
          link: "/trades-book-management",
          parentId: "trades",
        },
        {
          id: "bookManagementMT5",
          label: "Book Management MT5",
          link: "/trades-book-management-mt5",
          parentId: "trades",
        },
        {
          id: "orderSummary",
          label: "Order Summary",
          link: "/trades-order-summary",
          parentId: "trades",
        },
        {
          id: "demoStaleOrders",
          label: "Demo Stale Orders",
          link: "/trades-demo-stale-orders",
          parentId: "trades",
        },
        {
          id: "mt5WinnersLosers",
          label: "MT5 Winner Loser",
          link: "/trades-mt5-winners-losers",
          parentId: "trades",
        },
        {
          id: "myntWinnersLosers",
          label: "Mynt Winner Loser",
          link: "/trades-mynt-winners-losers",
          parentId: "trades",
        },
      ],
    },
    {
      id: "transactions",
      label: "Transactions",
      icon: "ri-exchange-line",
      link: "/#",
      click: function (e) {
        e.preventDefault();
        setIsTransactions(!isTransactions);
        setIscurrentState("Transactions");
        updateIconSidebar(e);
      },
      stateVariables: isTransactions,
      subItems: [
        //  {
        //   id: "paymentMethods",
        //   label: "Payment Methods",
        //   link: "/#",
        //   parentId: "transactions",
        //   isChildItem: true,
        //   click: function (e) {
        //     e.preventDefault();
        //     setIsPaymentMethods(!isPaymentMethods);
        //   },
        //   stateVariables: isPaymentMethods,
        //   childItems: [
        //     {
        //       id: "depositRequest",
        //       label: "Deposit Request",
        //       link: "/payments-deposit-request",
        //       parentId: "transactions",
        //     },
        //     {
        //       id: "withdrawRequest",
        //       label: "Withdraw Request",
        //       link: "/payments-withdraw-request",
        //       parentId: "transactions",
        //     },
        //     {
        //       id: "depositRequestMT5",
        //       label: "Deposit Request MT5",
        //       link: "/payments-deposit-request-mt5",
        //       parentId: "transactions",
        //     },
        //     {
        //       id: "withdrawRequestMT5",
        //       label: "Withdraw Request MT5",
        //       link: "/payments-withdraw-request-mt5",
        //       parentId: "transactions",
        //     },
        //   ],
        // },
        // {
        //   id: "deposit",
        //   label: "Deposit",
        //   link: "/transactions-deposit",
        //   parentId: "transactions",
        // },
        // {
        //   id: "withdraw",
        //   label: "Withdraw",
        //   link: "/transactions-withdraw",
        //   parentId: "transactions",
        // },
        {
          id: "depositRequest",
          label: "Deposit Request",
          link: "/payments-deposit-request",
          parentId: "transactions",
        },
        {
          id: "withdrawRequest",
          label: "Withdraw Request",
          link: "/payments-withdraw-request",
          parentId: "transactions",
        },
        {
          id: "depositRequestMT5",
          label: "Deposit Request MT5",
          link: "/payments-deposit-request-mt5",
          parentId: "transactions",
        },
        {
          id: "withdrawRequestMT5",
          label: "Withdraw Request MT5",
          link: "/payments-withdraw-request-mt5",
          parentId: "transactions",
        },
        // {
        //   id: "trxHistory",
        //   label: "Trx. History",
        //   link: "/transactions-history",
        //   parentId: "transactions",
        // },
        // {
        //   id: "internalTransfer",
        //   label: "Internal Transfer",
        //   link: "/transactions-internal-transfer",
        //   parentId: "transactions",
        // },
        // {
        //   id: "creditIn",
        //   label: "Credit In",
        //   link: "/transactions-credit-in",
        //   parentId: "transactions",
        // },
        // {
        //   id: "creditOut",
        //   label: "Credit Out",
        //   link: "/transactions-credit-out",
        //   parentId: "transactions",
        // },
      ],
    },
    {
      id: "mam",
      label: "MAM",
      icon: "ri-group-line",
      link: "/#",
      click: function (e) {
        e.preventDefault();
        setIsMAM(!isMAM);
        setIscurrentState("MAM");
        updateIconSidebar(e);
      },
      stateVariables: isMAM,
      subItems: [
        {
          id: "managers",
          label: "Managers",
          link: "/mam-managers",
          parentId: "mam",
        },
        {
          id: "investors",
          label: "Investors",
          link: "/mam-investors",
          parentId: "mam",
        },
        {
          id: "managerCommissionHistory",
          label: "Manager Commission History",
          link: "/mam-manager-commission-history",
          parentId: "mam",
        },
      ],
    },
    {
      id: "apps",
      label: "Apps",
      icon: "ri-apps-line",
      link: "/#",
      click: function (e) {
        e.preventDefault();
        setIsAppManagement(!isAppManagement);
        setIscurrentState("AppManagement");
        updateIconSidebar(e);
      },
      stateVariables: isAppManagement,
      subItems: [
        {
          id: "appVersion",
          label: "App Version",
          link: "/apps-app-version",
          parentId: "apps",
        },
        {
          id: "sendNotification",
          label: "Send Notification",
          link: "/apps-send-notification",
          parentId: "apps",
        },
        {
          id: "addBanner",
          label: "Add Banner",
          link: "/apps-add-banner",
          parentId: "apps",
        },
        //commented to use it in future development
        {
          id: "coupons",
          label: "Coupons",
          link: "/apps-coupons",
          parentId: "apps",
        },
      ],
    },
    {
      id: "reports",
      label: "Reports",
      icon: "ri-file-chart-line",
      link: "/#",
      click: function (e) {
        e.preventDefault();
        setIsReports(!isReports);
        setIscurrentState("Reports");
        updateIconSidebar(e);
      },
      stateVariables: isReports,
      subItems: [
        {
          id: "depositsReport",
          label: "Deposits Report",
          link: "/reports-deposits",
          parentId: "reports",
        },
        {
          id: "withdrawReport",
          label: "Withdraw Report",
          link: "/reports-withdraw",
          parentId: "reports",
        },
        {
          id: "depositsReportMt5",
          label: "Deposits Report MT5",
          link: "/reports-deposits-mt5",
          parentId: "reports",
        },
        {
          id: "withdrawReportMt5",
          label: "Withdraw Report MT5",
          link: "/reports-withdraw-mt5",
          parentId: "reports",
        },
        {
          id: "closedOrdersReport",
          label: "Closed Orders",
          link: "/reports-closed-orders",
          parentId: "reports",
        },
      ],
    },
    {
      id: "setting",
      label: "Setting",
      icon: "ri-settings-3-line",
      link: "/#",
      click: function (e) {
        e.preventDefault();
        setIsSetting(!isSetting);
        setIscurrentState("Setting");
        updateIconSidebar(e);
      },
      stateVariables: isSetting,
      subItems: [
        {
          id: "leverage",
          label: "Leverage",
          link: "/setting-leverage",
          parentId: "setting",
        },
        {
          id: "accGroupsAndLimits",
          label: "Acc. Groups and limits",
          link: "/setting-acc-groups-limits",
          parentId: "setting",
        },
        {
          id: "depositPayment",
          label: "Deposit Payment Methods",
          link: "/payments-deposit-payment",
          parentId: "setting",
        },
        {
          id: "withdrawPayment",
          label: "Withdraw Payment Methods",
          link: "/payments-withdraw-payment",
          parentId: "setting",
        },
        {
          id: "depositWithdrawConversion",
          label: "Deposit Withdraw Conversion",
          link: "/setting-deposit-withdraw-conversion",
          parentId: "setting",
        },
        {
          id: "countryConfig",
          label: "Country Config",
          link: "/setting-country-config",
          parentId: "setting",
        },
      ],
    },
    {
      id: "admins",
      label: "Admins",
      icon: "ri-admin-line",
      link: "/#",
      click: function (e) {
        e.preventDefault();
        setIsAdmins(!isAdmins);
        setIscurrentState("Admins");
        updateIconSidebar(e);
      },
      stateVariables: isAdmins,
      subItems: [
        {
          id: "adminList",
          label: "Admin List",
          link: "/admins-list",
          parentId: "admins",
        },
        {
          id: "loginRecords",
          label: "Login Records",
          link: "/admins-login-records",
          parentId: "admins",
        },
      ],
    },
    // {
    //   id: "widgets",
    //   label: "Widgets",
    //   icon: "ri-honour-line",
    //   link: "/widgets",
    //   click: function (e) {
    //     e.preventDefault();
    //     setIscurrentState("Widgets");
    //   },
    // },
  ];

  const filteredMenuItems = isManager()
    ? menuItems
        .map((item) => {
          if (item.id === "account" && Array.isArray(item.subItems)) {
            return {
              ...item,
              subItems: item.subItems.filter(
                (sub) => !MANAGER_HIDDEN_ACCOUNT_SUBMENU_IDS.includes(sub.id)
              ),
            };
          }
          return item;
        })
        .filter((item) => !MANAGER_HIDDEN_MENU_IDS.includes(item.id))
    : menuItems;

  return <React.Fragment>{filteredMenuItems}</React.Fragment>;
};
export default Navdata;
